import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { HISTORICAL_DATA } from '../../constants';
import { MarketButton } from '../../styledComponents';

const historicalDataArray = HISTORICAL_DATA;

const AccordionItem = ({
  data = {},
  findObjectAndUpdate,
  openMarketPopup,
  markets,
}) => {
  const [marketCount, setMarketCount] = useState('');
  useEffect(() => {
    if (data.optionName === 'Local Flex' && markets.length) {
      const selectedMarket = markets.find(data => data.studySource === 1);
      if (selectedMarket) {
        setMarketCount(selectedMarket.ids.length);
      } else {
        setMarketCount('');
      }
    } else {
      setMarketCount('');
    }
  }, [markets]);
  return (
    <Fragment>
      <div
        className={
          data.isAnyChildSelected
            ? 'ent-table-content-study isAnyItemSelected'
            : 'ent-table-content-study'
        }
      >
        <input
          type="checkbox"
          id="selected"
          key={Math.random()}
          value={data.selected}
          defaultChecked={data.selected}
          onChange={e => {
            findObjectAndUpdate(data, e, e.target.checked);
          }}
        />
        <label htmlFor={data.optionId} title={data.optionName}>
          {data.optionName}
        </label>
        {data.optionName === 'Local Flex' && (
          <span className="market-btn">
            <MarketButton
              id={data.optionId}
              disabled={!data.selected && !data.isAnyChildSelected}
              onClick={() => {
                openMarketPopup(data);
              }}
            >
              Market
            </MarketButton>
            <span className="market-count">
              {marketCount ? `[ ${marketCount} ]` : ''}
            </span>
          </span>
        )}
      </div>
      <div className="ent-table-content-history">
        <select
          value={data.historicalData || ''}
          disabled={!(data.selected || data.isAnyChildSelected)}
          id="historicalData"
          onChange={e => findObjectAndUpdate(data, e, e.target.value)}
          key={Math.random()}
        >
          {historicalDataArray.map(item => (
            <option key={item.value}>{item.value}</option>
          ))}
        </select>
      </div>
      <div className="ent-table-content-auto">
        <input
          type="checkbox"
          key={Math.random()}
          disabled={!(data.selected || data.isAnyChildSelected)}
          id="autoAdd"
          onChange={e => findObjectAndUpdate(data, e, e.target.checked)}
          defaultChecked={data.autoAdd}
        />
      </div>
      <div className="ent-table-content-old">
        <input
          type="checkbox"
          key={Math.random()}
          disabled={!(data.selected || data.isAnyChildSelected)}
          defaultChecked={data.autoRemove}
          value={data.autoRemove}
          id="autoRemove"
          onChange={e => findObjectAndUpdate(data, e, e.target.checked)}
        />
      </div>
    </Fragment>
  );
};
AccordionItem.propTypes = {
  data: PropTypes.shape({}),
  findObjectAndUpdate: PropTypes.func,
  openMarketPopup: PropTypes.func,
  markets: PropTypes.arrayOf(PropTypes.object),
};
export default React.memo(AccordionItem);
